import {
  params,
  string,
  shape,
  arrayOf,
  bool,
  number,
  customType,
  extend
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';

const ProductModel = extend({}, { itemId: string() }, ProductPod.dataModel.product);

export const productRefinementCountDataModel = {
  refinementCountModel: params({
    navParam: string(),
    keyword: string(),
    isBrandPricingPolicyCompliant: bool(),
    storeId: string(),
    channel: customType('Channel').enum(['DESKTOP', 'MOBILE', 'TABLET'], 'DESKTOP'),
    storefilter: customType('StoreFilter').enum(['ALL', 'IN_STORE', 'ONLINE'], 'ALL'),
    additionalSearchParams: customType('AdditionalParams').shape({
      multiStoreIds: arrayOf(string()),
      sponsored: bool(),
      deliveryZip: string(),
      plp: bool()
    }),
    loyaltyMembershipInput: customType('LoyaltyMembershipInput').shape({
      svocID: string(),
      programTiers: arrayOf(
        shape({
          tier: string(),
          program: string()
        })
      )
    })
  }).shape({
    id: string(),
    metadata: shape({
      productCount: shape({
        inStore: string()
      })
    }),
    searchReport: shape({
      totalProducts: number()
    }),
    dimensions: arrayOf(
      shape({
        label: string()
      })
    ),
    products: params({
      filter: customType('ProductFilter').shape({
        rangefilter: string(),
        lowerBound: number(),
        upperBound: number()
      })
    }).arrayOf(ProductModel),
    apiUrls: arrayOf(string())
  })
};
